import { AxiosError } from 'axios';
import { clearStorage } from '@/utils/storage';
import store from '@/store';
import router from '@/plugins/router';

// 处理 http 错误
export function httpError(error: AxiosError) {
  if (error.response) {
    // 已发出请求，收到了 http 错误
    let errMsg: string;
    const status = error.response.status;
    switch (status) {
      case 401:
        errMsg = '登录信息过期，请重新登录';
        clearStorage();
        router.push({ name: 'login' });
        break;
      case 404:
        errMsg = '请求不存在';
        break;
      case 500:
      case 502:
        errMsg = '系统繁忙，请稍后再试';
        break;
      default:
        errMsg = `未知错误，系统返回码：${status}`;
        break;
    }
    store.commit('common/setToast', { visible: true, text: errMsg });
  } else if (error.request) {
    // 已发出请求，但未收到响应
    store.commit('common/setToast', { visible: true, text: '服务器未响应，请稍后再试' });
  } else {
    store.commit('common/setToast', { visible: true, text: error.message });
  }
}

// 业务错误处理
export function rtnError(rtnCode: number, message: string) {
  let errMsg;
  switch (true) {
    case rtnCode === -1000:
      errMsg = message;
      break;
    case rtnCode === 216:
      errMsg = '组织状态异常';
      break;
    case rtnCode === 217:
      errMsg = '用户/会员状态异常';
      break;
    case rtnCode === 1001:
      errMsg = '用户名或密码错误';
      break;
    case rtnCode === 1002:
      errMsg = '验证码错误';
      break;
    case rtnCode === 1018:
      errMsg = '手机号码已存在';
      break;
    case rtnCode === 1019:
      errMsg = '会员未找到';
      break;
    case rtnCode === 1020:
      errMsg = '会员状态异常';
      break;
    case rtnCode === 10017:
      errMsg = '会员组织状态异常';
      break;
    case rtnCode === 10018:
      errMsg = '会员组织未找到';
      break;
    case rtnCode === 22000:
      errMsg = '验证失败';
      break;
    case rtnCode === 22001:
      errMsg = '发送失败';
      break;
    case rtnCode === 22002:
      errMsg = '操作频繁';
      break;
    case rtnCode === 22003:
      errMsg = '短信类型不支持';
      break;
    case [8002].indexOf(rtnCode) !== -1:
      errMsg = '';  // 这一块的业务异常信息，需要做单独组件显示，不是用 toast 通知显示
      break;
    case !!message:
      errMsg = message;
      break;
    default:
      errMsg = `系统错误, 错误码：${rtnCode}`;
      break;
  }
  if (errMsg) {
    store.commit('common/setToast', { visible: true, text: errMsg });
  }
}
